<template>
  <div class="py-16 md:py-24 bg-background">
    <div class="container max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      
      <div class="text-center space-y-4 mb-16">
        <h1 class="text-4xl font-bold text-foreground">Contact Us</h1>
        <p class="text-muted-foreground">Our fire safety experts are available 24/7 for emergency support and inquiries.</p>
      </div>

      <div class="grid grid-cols-1 lg:grid-cols-2 gap-12">
        <!-- Contact Info -->
        <div class="space-y-8">
          <div class="bg-white p-8 rounded-2xl shadow-sm border border-border">
            <h3 class="text-xl font-bold mb-6">Get In Touch</h3>
            
            <div class="space-y-6">
              <div class="flex items-start gap-4">
                <div class="w-12 h-12 bg-red-50 text-primary rounded-full flex items-center justify-center shrink-0">
                  <component :is="PhoneIcon" class="w-6 h-6" />
                </div>
                <div>
                  <h4 class="font-bold">Phone Support</h4>
                  <p class="text-slate-600 text-sm mt-1">Tel: +974 4140 0922</p>
                  <p class="text-slate-600 text-sm">Mob: +974 3081 2223</p>
                </div>
              </div>

              <div class="flex items-start gap-4">
                <div class="w-12 h-12 bg-red-50 text-primary rounded-full flex items-center justify-center shrink-0">
                  <component :is="MailIcon" class="w-6 h-6" />
                </div>
                <div>
                  <h4 class="font-bold">Email Us</h4>
                  <p class="text-slate-600 text-sm mt-1">Office: info@alarmsupplies.qa</p>
                </div>
              </div>

              <div class="flex items-start gap-4">
                <div class="w-12 h-12 bg-red-50 text-primary rounded-full flex items-center justify-center shrink-0">
                  <component :is="MapPinIcon" class="w-6 h-6" />
                </div>
                <div>
                  <p class="text-slate-600 text-sm mt-1">Suhaim Tower, Al-Sadd<br/>Doha, Qatar</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Contact Form -->
        <div class="bg-white p-8 rounded-2xl shadow-sm border border-border">
          <h3 class="text-xl font-bold mb-6">Send a Message</h3>
          <form class="space-y-4" @submit.prevent="">
            <div class="grid grid-cols-2 gap-4">
              <div class="space-y-1.5">
                <label class="text-sm font-medium">First Name</label>
                <input type="text" class="w-full px-4 py-2 border border-border rounded-lg focus:ring-2 focus:ring-primary focus:outline-none" />
              </div>
              <div class="space-y-1.5">
                <label class="text-sm font-medium">Last Name</label>
                <input type="text" class="w-full px-4 py-2 border border-border rounded-lg focus:ring-2 focus:ring-primary focus:outline-none" />
              </div>
            </div>
            
            <div class="space-y-1.5">
              <label class="text-sm font-medium">Email Address</label>
              <input type="email" class="w-full px-4 py-2 border border-border rounded-lg focus:ring-2 focus:ring-primary focus:outline-none" />
            </div>

            <div class="space-y-1.5">
              <label class="text-sm font-medium">Topic</label>
              <select class="w-full px-4 py-2 border border-border rounded-lg focus:ring-2 focus:ring-primary focus:outline-none">
                <option>General Inquiry</option>
                <option>Quote Request</option>
                <option>System Maintenance</option>
                <option>Order Support</option>
              </select>
            </div>
            
            <div class="space-y-1.5">
              <label class="text-sm font-medium">Message</label>
              <textarea rows="4" class="w-full px-4 py-2 border border-border rounded-lg focus:ring-2 focus:ring-primary focus:outline-none"></textarea>
            </div>

            <button type="submit" class="w-full btn btn-primary h-12 text-base shadow-lg shadow-primary/30">
              Send Message
            </button>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { Phone as PhoneIcon, Mail as MailIcon, MapPin as MapPinIcon } from 'lucide-vue-next'

useSeoMeta({
  title: 'Contact Us | ALARM Fire Safety',
  description: 'Get in touch with ALARM Fire Safety for inquiries, quote requests, or 24/7 emergency support on fire protection systems.'
})
useHead({
  link: [{ rel: 'canonical', href: 'https://alarmsupplies.qa/contact' }]
})
</script>
